import client from "graphql/client";
import i18next from "i18next";
import { loader } from "graphql.macro";
import { BOOK_LOADED } from "redux/types";
import { snackbarSuccess, snackbarError } from "shared/redux/actions/Snackbar";
import createBookFromData from "helpers/createBookFromData";

const addBookMutation = loader("graphql/mutations/books/addBook.graphql");

export function bookAdd() {
    return async (dispatch, getState) => {
        const { current: organisation } = getState().organisation;

        try {
            const { data } = await client.mutate({
                mutation: addBookMutation,
                variables: { organisationId: organisation.id },
            });

            const { addBook: bookData } = data;
            const book = createBookFromData(bookData);

            dispatch({
                type: BOOK_LOADED,
                id: bookData.osbn,
                book
            });

            dispatch(snackbarSuccess(i18next.t("books.add.success")));

            return book;
        } catch (error) {
            console.error(error);
            dispatch(snackbarError(i18next.t("books.add.failed")));
        }
    };
}